<template>
  <el-table
    :border="true"
    id="rebateSetTable"
    :data="list"
    ref="table"
    :max-height="tableHeight"
    v-loading="loading"
    element-loading-text="拼命加载中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.1)"
    class="summarytable"
  >
    <el-table-column
      v-for="item in column"
      :prop="item.key"
      :label="item.name"
      :key="item.key"
      :width="item.width"
      :fixed="item.fixed"
      align="center"
      :sortable="item.sort"
      :sort-method="item.sortMethod"
    >
      <template #header>
        <span>{{ item.name }}</span>
        <span style="margin-left: 10px" v-if="item.copy">
          <i @click.stop="onClick(item.key, item.name, item.percent, item.unit)" class="el-icon-document-copy"> </i
        ></span>
      </template>
      <el-table-column
        :prop="item.key"
        :label="totalColumn[item.key] ? totalColumn[item.key] + '' : ''"
        :width="item.width"
        :key="item.key"
        align="center"
      >
        <template slot-scope="scope">
          <span
            >{{ scope.row[item.key] ? (item.unit ? (searchData.currencyType === "USD" ? "$" : "￥") : "") : null
            }}{{
              Number(scope.row[item.key]) && item.key !== "campaign"
                ? scope.row[item.key].toFixed(item.point)
                : scope.row[item.key]
                ? scope.row[item.key]
                : "-"
            }}{{ scope.row[item.key]  ? item.percent : null }}</span
          >
        </template>
      </el-table-column>
    </el-table-column>
  </el-table>
</template>

<script>
import XLSX from "xlsx";
import FileSaver from "file-saver";
import { copyText } from "../../utils/tool";
import { calculateTotal } from "./calculateTotal.js";
export default {
  data() {
    return {
      tableHeight: window.innerHeight - 280,
      totalColumn: {},
    };
  },
  computed: {
    totalEstimateTimes: function () {
      return this.$store.state.SummaryTest.totalEstimateTimes;
    },
  },
  props: {
    list: Array,
    column: Array,
    loading: Boolean,
    deleteRoI: String,
    searchData: Object,
  },
  watch: {
    list(value) {
      let totalData = {};
      if (value.length > 0) {
        totalData = calculateTotal(this.column, this.list, this.$store.state.SummaryTest, this.searchData.currencyType);
      }
      totalData.mediaSource = "合计";
      this.totalColumn = totalData;
    },
  },
  mounted() {
    let _this = this;
    window.onresize = () => {
      return _this.refresh() || null;
    };
  },
  methods: {
    downLoadFileToExcel() {
      let fix = document.querySelector(".el-table__fixed");
      var xlsxParam = { raw: true }; //导出的内容只做解析，不进行格式转换(添加此行代码表格中的百分比就不会再导出的时候被转换成小数点)
      let wb;
      if (fix) {
        //判断要导出的节点中是否有fixed的表格，如果有，转换excel时先将该dom移除，然后append回去
        wb = XLSX.utils.table_to_book(document.querySelector("#rebateSetTable").removeChild(fix), xlsxParam);
        document.querySelector("#rebateSetTable").appendChild(fix);
      } else {
        wb = XLSX.utils.table_to_book(document.querySelector("#rebateSetTable"), xlsxParam);
      }
      let wbout = XLSX.write(wb, {
        bookType: "xlsx",
        bookSST: true,
        type: "array",
      });
      try {
        FileSaver.saveAs(new Blob([wbout], { type: "application/octet-stream" }), "汇总.xlsx");
      } catch (e) {
        if (typeof console !== "undefined") console.log(e, wbout);
      }
      return wbout;
    },
    refresh() {
      this.tableHeight = window.innerHeight - 280;
      this.$nextTick(() => {
        this.$refs.table && this.$refs.table.doLayout();
      });
    },
    onClick(key, name, percent, unit) {
      let arr = [];
      if (percent) {
        arr = this.list.map((item) => {
          if (item[key]) {
            return `${item[key]}%`;
          } else {
            return `0%`;
          }
        });
      } else {
        if (unit) {
          arr = this.list.map((item) => {
            if (item[key]) {
              return `$${item[key]}`;
            } else {
              return `$0`;
            }
          });
        } else {
          arr = this.list.map((item) => {
            if (item[key]) {
              return `${item[key]}`;
            } else {
              return `0`;
            }
          });
        }
      }

      this.$message({
        message: `已粘贴${name}到剪切板`,
        type: "success",
      });
      let string = arr.join("\n");

      copyText(string);
    },
  },
};
</script>
<style lang="less" rel="stylesheet/less" scoped>
.el-table {
  overflow: visible !important;
}
// .summarytable {
//   height: 723px;
// }
// .showRoi table thead tr th:nth-child(12) {
//   display: none !important;
// }
// .showRoi table tbody tr td:nth-child(12) {
//   display: none;
// }
</style>
